import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin( ScrollTrigger );

let
	mqMediumUp = window.matchMedia( '(min-width: 768px)' ),
	mqXLargeUp = window.matchMedia( '(min-width: 1200px)' ),
	components = [],
	timelines  = [],
	swiper     = null;

function initCTAList() {
	components = document.querySelectorAll( '.c-cta-list' );

	mqMediumUp.matches ? killSliders() : buildSliders();

	mqMediumUp.addEventListener( 'change', (event) => {
		event.matches ? killSliders() : buildSliders();
		updateAnimations();
	});

	mqXLargeUp.addEventListener( 'change', (event) => {
		updateAnimations();
	});

	updateAnimations();
}

function updateAnimations() {
	if( window.matchMedia('(prefers-reduced-motion: reduce)').matches ) {
		return;
	}

	destroyAnimations();

	if( ! mqMediumUp.matches ) {
		return;
	}
	
	components.forEach( component => {
		initComponentAnimations( component );
	});
}

function destroyAnimations() {
	timelines.forEach( timeline => {
		timeline.kill();
	});

	timelines = [];
}

function initComponentAnimations( component ) {
	let
		items   = [...component.querySelectorAll( '.c-cta-list_item' )],
		heading = component.querySelector( '.c-cta-list_heading' ),
		offsets = {
			medium: [ '-150px', '0px', '150px' ],
			xlarge: [ '-300px', '-150px', '150px', '300px' ]
		};

	offsets = mqXLargeUp.matches ? offsets.xlarge : offsets.medium;

	//console.log( 'initComponentAnimations' );
	//console.log( mqXLargeUp.matches ? offsets.xlarge : offsets.medium );

	if( mqXLargeUp.matches ) {
		items.unshift( heading );
	}

	items.forEach( ( item, i ) => {
		gsap.set( item, { translateX: offsets[i] } );
	});
	
	timelines.push(
		gsap.timeline({
			scrollTrigger: {
				trigger: component,
				scrub: 1,
				start: 'top bottom',
				end: 'bottom-=50% top+=50%'
			}
		})
		.to( items, { 
			keyframes: [
				{ duration: 1, translateX: '0px' },
			]
		})
	);	

}

function killSliders() {
	if( null === swiper ) {
		return;
	}

	swiper.destroy();
	
	document.querySelectorAll( '.c-cta-list [data-mobile-class]' ).forEach( element => {
		element.classList.remove( element.dataset.mobileClass );
	});
}

function buildSliders() {
	document.querySelectorAll( '.c-cta-list [data-mobile-class]' ).forEach( element => {
		element.classList.add( element.dataset.mobileClass );
	});

	try {
	
		swiper = new Swiper( '.c-cta-list .swiper-container', {
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			}
		});
	} catch (e) {
		console.log(e.message);
	}
}

export {initCTAList}
